import React, { Component } from 'react';
import TextField from "material-ui/TextField"
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import { CircularProgress } from 'material-ui/Progress';

import green from 'material-ui/colors/green';

import Dialog, { DialogTitle, DialogContentText,DialogContent,DialogActions } from 'material-ui/Dialog';

import Select from 'react-select';
import 'react-select/dist/react-select.css';
import {FormControlLabel} from 'material-ui/Form';

import { ajaxPost } from '../ajax';
import Typography from 'material-ui/Typography/Typography';
import Switch from 'material-ui/Switch';

const styles = theme => ({
      fabProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -15,
        marginLeft: -15,
          },
      wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
        display:'inline-flex',
      },
      select:
      {
         margin: theme.spacing.unit,
          width:400,
          display:"inline-flex"
      },
      paper:
      {
          overflow:"visible"
      },
});

class SelectMultipleDevice extends Component {
        state =
        {
            busy : false,
            device:[],
        }

        handleClose = ()=>
        {
            if( this.props.onClose != null )
                this.props.onClose(false);
        }

        handleAction = ()=>
        {
            this.setState({busy:true});
                this.props.onAction(this.state.device);
        }

        handleChange  = (value) =>
        {
            this.setState({
                device: value,
            });
        }
    
        getData = (input,callback) =>
        {
            var data =
                {
                    Payload: 
                    {
                        Search:input,
                        OfflineOnly:false,
                        ActiveOnly:true,
                    },
                    SessionID:"",
                    StartIndex: 0,
                    MaxData: 50,
                };

            window.fetch(window.apihost + '/DeviceAPI/ListDevices',
                {
                    headers: {
                        'Accept': 'application/json, text/plain, */*',
                        'Content-Type': 'application/json'
                    },
                    method: 'post',
                    body: JSON.stringify(data)
                })
                .then((response) => {
                    return response.json();
                }).then((json) => {
                    callback(null, {
                        options:JSON.parse(json.JsonData),
                        complete: true
                    });
                });
        }
    
        render = ()=>
        {
            const {classes} = this.props;
            const paperProps = 
            {
                style:{"overflow":"visible"}
            }

            return (
                <div>
                    
            <Dialog
            open={true}
            classes={classes}
            >
            <DialogTitle >{this.props.title}</DialogTitle>
            <DialogContent style={{"overflow":"visible"}}>
                <DialogContentText>
                    {this.props.caption}
                    </DialogContentText>
            <Select.Async disabled={this.state.busy}
                value={this.state.device} 
                onChange={this.handleChange.bind(this)} 
                loadOptions={this.getData.bind(this)} 
                isLoading={true}
                labelKey="DeviceName"
                valueKey="DeviceName"
                className={classes.select}
                multi={true}
             />
            </DialogContent>
            <DialogActions>
            <Button onClick={this.handleClose} color="primary" disabled={this.state.busy}>
            Cancel
            </Button>
            <div className={classes.wrapper}>
                <Button disabled={this.state.busy} 
                color="primary" className={classes.button} onClick={this.handleAction}>
                SELECT
                </Button>
                {this.state.busy && <CircularProgress size={30} className={classes.fabProgress} />}
            </div>
            </DialogActions>
            </Dialog>            
            </div>
            )
        }
}


export default withStyles(styles)(SelectMultipleDevice);


// WEBPACK FOOTER //
// ./src/monitor/SelectMultipleDevice.js